import { API } from 'aws-amplify'

import {
  updateDgtPdOrderOperationLog,
  deleteDgtPdOrderOperationLog
} from '../graphql/mutations'
import {
  getDgtPdOrderOperationLog,
  operationLogByOrderIdAndNo
} from '../graphql/queries'
import { DgtPdOrderOperationLog } from '../models'

export const updateLogSplit = async (logId: string, splitNo: number) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const updateResult : any = await API.graphql({
      query: updateDgtPdOrderOperationLog,
      variables: { input: {
        _version: version, 
        id: logId,
        split: splitNo
      }}
    })
    if (updateResult.data) return updateResult.data.updateDgtPdOrderOperationLog
  }
}

const updateLogConfirmation = async (logId: string, confId: string, confDate: string, confBy: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const updateResult : any = await API.graphql({
      query: updateDgtPdOrderOperationLog,
      variables: { input: {
        _version: version, 
        id: logId,
        confirmationId: confId,
        confirmedDate: confDate,
        confirmedBy: confBy,
      }}
    })
    if (updateResult.data) return updateResult.data.updateDgtPdOrderOperationLog
  }
}

export const updateConfirmationLogs = async (
  selectedLog: DgtPdOrderOperationLog[],
  confId: string, confDate: string, confBy: string
) => {
  const updatePromise = selectedLog
    .map(log => updateLogConfirmation(log.id, confId, confDate, confBy))
  return await Promise.allSettled(updatePromise)
}

export const updateLogShift = async (logId: string, shift: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const updateResult : any = await API.graphql({
      query: updateDgtPdOrderOperationLog,
      variables: { input: {
        _version: version, 
        id: logId,
        shift
      }}
    })
    if (updateResult.data) return updateResult.data.updateDgtPdOrderOperationLog
  }
}

export const updateLogMch = async (logId: string, mch: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const updateResult : any = await API.graphql({
      query: updateDgtPdOrderOperationLog,
      variables: { input: {
        _version: version, 
        id: logId,
        mch
      }}
    })
    if (updateResult.data) return updateResult.data.updateDgtPdOrderOperationLog
  }
}

export const getOperationLogs = async (orderId: string, opNo: string) : Promise<DgtPdOrderOperationLog[]> => {
  const listResult: any = await API.graphql({
    query: operationLogByOrderIdAndNo,
    variables: {
      productionOrderId: orderId,
      operationNo: { eq: opNo },
      filter: {
        _deleted: { ne: true }
      }
    }
  })
  const operationLogs: DgtPdOrderOperationLog[] = 
    listResult.data?.operationLogByOrderIdAndNo.items
  operationLogs.sort((a, b) => (a.startedTime || 0) > (b.startedTime || 0) ? 1 : -1)
  return operationLogs
}

export const getOperationLogsAll = async (orderId: string) : Promise<DgtPdOrderOperationLog[]> => {
  const listResult: any = await API.graphql({
    query: operationLogByOrderIdAndNo,
    variables: {
      productionOrderId: orderId,
      filter: {
        _deleted: { ne: true }
      }
    }
  })
  const operationLogs: DgtPdOrderOperationLog[] = 
    listResult.data?.operationLogByOrderIdAndNo.items
  operationLogs.sort((a, b) => (a.startedTime || 0) > (b.startedTime || 0) ? 1 : -1)
  return operationLogs
}

export const deleteLog = async (logId: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const deleteResult : any = await API.graphql({
      query: deleteDgtPdOrderOperationLog,
      variables: { input: {
        _version: version,
        id: logId
      }}
    })
    if (deleteResult.data) return deleteResult.data.deleteDgtPdOrderOperationLog
  }
}

export const updateLogBatchLot = async (logId: string, lot?: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperationLog,
    variables: { id: logId }
  })
  if (getResult.data?.getDgtPdOrderOperationLog) {
    const version = getResult.data?.getDgtPdOrderOperationLog._version
    const updateResult : any = await API.graphql({
      query: updateDgtPdOrderOperationLog,
      variables: { input: {
        _version: version, 
        id: logId,
        batchNo: lot || null
      }}
    })
    if (updateResult.data) return updateResult.data.updateDgtPdOrderOperationLog
  }
}